import { MARQUEE } from "@/data/content";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div className="marquee relative overflow-hidden border-y border-white/[0.06] bg-[#0d0d0f] py-5" data-testid="marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-32 bg-gradient-to-r from-[#0d0d0f] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-32 bg-gradient-to-l from-[#0d0d0f] to-transparent" />
      <div className="marquee-track">
        {items.map((t, i) => (
          <span key={i} className="flex items-center gap-10 pr-10">
            <span className={`font-display whitespace-nowrap text-sm font-semibold uppercase tracking-[0.22em] ${i % 2 ? "text-white/40" : "text-white"}`}>
              {t}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--glow)] opacity-70" />
          </span>
        ))}
      </div>
    </div>
  );
};
